<template>
  <div>
    <RoomListItem v-for="room in rooms" :key="room.id" :room="room"></RoomListItem>
    <div>
      <router-link :to="{ name: 'RoomCreateView' }">Luo huone</router-link>
    </div>
  </div>
</template>

<script>

import RoomListItem from '@/components/RoomListItem';

export default {
  name: 'RoomListView',
  components: { RoomListItem },
  computed: {
    rooms () {
      return this.$store.state.rooms;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/RoomListView.vue